import { formatCurrency, formatDate, formatString, MONTHS } from "./functions.js";
import { PlanForecastNotes } from "./server-types/MonthSalesReportPlanForecastNotes.js";

import { app } from "./session.js";

class SalesReportForecast {
    plans: PlanForecastNotes[];
    constructor() {
        this.init();
    }

    private async init() {
        try {
            await this.loadPlans();
        } catch (error) {
            console.error('Failed to initialize Sales Report Manager:', error);
            this.showError('Failed to load data. Please refresh the page.');
        }
    }

    private getDates() {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        const currentYear = currentDate.getFullYear();

        const nextMonth = (currentMonth + 1) % 12;
        const nextYear = (currentMonth === 11) ? currentYear + 1 : currentYear;

        return {
            currentDate,
            currentMonth,
            currentYear,
            nextMonth,
            nextYear
        }
    }

    private async loadPlans() {
        try {
            const list = document.getElementById('plans-list');
            if (list)
                list.innerHTML = "Loading...";


            const dates = this.getDates();

            const current = app.API.getSelf(dates.currentYear, dates.currentMonth);
            const next = app.API.getSelf(dates.nextYear, dates.nextMonth);
            this.plans = [...(await current), ...(await next)];
            this.plans = this.plans.sort((a, b) => (a.year * 100 + a.month) - (b.year * 100 + b.month));
            this.render();

        } catch (error) {
            console.error('Failed to load plans:', error);
            this.showError('Failed to load plans for the selected year.');
        }
    }

    private async render() {
        const content = document.getElementById('content');
        if (!content) {
            throw new Error('Content element not found');
        }


        content.innerHTML = this.plans.map(plan => this.generatePlanHtml(plan)).join("");

        this.attachPlanEventListeners();
    }

    private generatePlanHtml(plan: PlanForecastNotes): string {
        var html = `
        <form class="update-forecast">
            <fieldset style="width: 500px; max-width: 500px; margin: 15px; display: inline-block">
                <legend>Forecast/Notes for ${MONTHS[plan.month]} ${plan.year} ${plan.planName ? `(${plan.planName})` : ""}</legend>
                <input type="hidden" name="plan-id" value="${plan.id}">
                <input type="hidden" name="plan-month" value="${plan.month}">
                <label style="width:150px; display: inline-block;">Budget:</label> ${formatCurrency(plan.goal)} <br>
                <label style="width:150px; display: inline-block;">Month-to-Date:</label> ${formatCurrency(plan.monthToDate)} <br>`;

        if (plan.notes.length > 0) {
            html += `<label style="width:150px; display: inline-block;">Notes</label>
            <ul>
                ${plan.notes.map(n => `<li>${formatDate(n.time)} - ${formatString(n.message)}</li>`).join("")}
            </ul>
            `;
        }

        html += `
                <label for="forecast" style="width:150px; display: inline-block;">Forecast:</label>
                <input class="form-control" type="number" id="forecast" name="forecast" value="${plan.forecast}" ${this.disableForecast(plan.month, plan.forecast) ? "disabled" : ""}>
                <br>
                <label for="note" style="width:150px; display: inline-block;">Add Note (optional):</label>
                <br>
                <textarea class="form-control" type="text" id="note" name="note" maxlength="100" rows="4" cols="30" style="resize: none;"></textarea><br>
                <button class="update-forecast-btn">Update current forecast</button>
            </fieldset>
        </form>`;
        return html;
    }

    private attachPlanEventListeners() {
        document.querySelectorAll(".update-forecast").forEach((element) => {
            element.addEventListener("submit", (async (e) => {
                e.preventDefault();

                const data = {
                    id: e.target['plan-id'].value,
                    month: parseInt(e.target['plan-month'].value),
                    forecast: parseInt(e.target['forecast'].value),
                    note: e.target['note'].value.trim()
                };
                console.log("Submitted change:", data);
                const results = [app.API.setSelfForecast(data.id, data.month, data.forecast)];
                if (data.note)
                    results.push(app.API.addSelfNote(data.id, data.month, data.note));

                await Promise.all(results);
                this.showSuccess("Updated Plan");
                this.init();
            }));
        });
    }

    private disableForecast(month: number, forecast: number) {
        const dates = this.getDates();
        return month == dates.currentMonth && forecast > 0;
    }

    private showSuccess(message: string) {
        alert("Success: " + message);
    }

    private showError(message: string) {
        // Simple error display - you might want to replace with your preferred notification system
        alert(`Error: ${message}`);
    }
}

// Initialize the manager when the page loads
export function initializeForecast() {
    new SalesReportForecast();
}
